module.exports = __webpack_public_path__ + "static/media/GAS.7b5f93a9.png";